import { React, useContext, useEffect, useRef, useState } from "react";
import { PageContext } from "../../App";
import {
  getFileExtension,
  formatBytes,
  saveFile,
  loadImageFromFile,
  fileToBase64,
  getExtensionFromMimeType,
} from "../Utils";
import ImageViewerView from "../image_viewer/ImageViewerView";
import CropRectSelectPopup from "../crop_pdf/CropRectSelectPopup";
import { cropImage } from "../ImageHelper/ImageRenderer";

function CropImageListImagesScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);
  //image info
  const [imageInfo, setImageInfo] = useState({
    state: AppState.NONE,
    thumbnail: null,
    message: "",
    mimeType: "",
    name: "",
    file: null, //selected file
    size: 0, //in bytes
    cropped_blob: null,
    cropped_size: 0,
  });
  //output settings
  //rect in percent width, height of page
  const [outputSettings, setOutputSettings] = useState({
    pageNumber: 1,
    cropX: 0, //percent x
    cropY: 0, //percent y
    cropWidth: 100, //percent width
    cropHeight: 100, //percent height
    type: {
      popupShowing: false,
      export_as: ".jpg",
      mimetype: "image/jpeg",
    },
  });
  //show popup select crop rect
  const [showSelectRectPopup, setShowSelectRectPopup] = useState({
    showing: false,
    image: null, //base64 image
    imageDimension: [0, 0], //dimenson in pixels
  });
  //is rotating
  const [isCropping, setIsCropping] = useState(false);

  //show image preview
  const [showImagePreview, setShowImagePreview] = useState({
    preview: false,
    file: null,
  });

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //generate thumbnail
      generateThumbnails();

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (selectedFiles.length === 0) {
      //reset
      resetScreen();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles]);

  //generate thumbnails
  const generateThumbnails = async () => {
    //check
    if (selectedFiles.length === 0) {
      //return
      return;
    }

    //load image
    const image = await loadImageFromFile(selectedFiles[0]);
    //set image
    setShowSelectRectPopup({
      ...showSelectRectPopup,
      image: await fileToBase64(selectedFiles[0]), //as file
      imageDimension: [image.width, image.height],
    });

    //selected file
    const selectedFile = selectedFiles[0];
    //set image info
    setImageInfo({
      ...imageInfo,
      state: AppState.LOADED,
      thumbnail: URL.createObjectURL(selectedFile),
      message: "",
      mimeType: selectedFile.type,
      name: selectedFile.name,
      file: selectedFile, //selected file
      size: selectedFile.size, //in bytes
      cropped_blob: null,
      cropped_size: 0,
    });
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setShowEditFileScreen(false);
    setImageInfo({
      state: AppState.NONE,
      thumbnail: null,
      message: "",
      mimeType: "",
      name: "",
      file: null, //selected file
      size: 0, //in bytes
      cropped_blob: null,
      cropped_size: 0,
    });
    setStartProcessingFiles(false);
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    selectedFiles.map((item, index) => (
      <div
        className="mt-3"
        key={index}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          //show preview
          setShowImagePreview({
            ...showImagePreview,
            preview: true,
            file:
              imageInfo.cropped_blob === null ? item : imageInfo.cropped_blob,
          });
        }}
      >
        {/* Flex container left image right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  imageInfo.thumbnail != null
                    ? imageInfo.thumbnail
                    : "./images/file_icon.png"
                }
                alt="image_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">{item.name}</div>
            <div className="d-flex">
              {/* File size */}
              <div className="px-2 fs-6 text-body-secondary">
                Size: {formatBytes(item.size)}
              </div>
              {/* file type */}
              <div
                className={`px-2 ms-2 my-auto rounded-2 fw-bold ${
                  imageInfo.state === AppState.PROCESSED
                    ? "text-success"
                    : "bg-danger text-white"
                }`}
              >
                {imageInfo.state === AppState.PROCESSED
                  ? "PROCESSED"
                  : getFileExtension(item.name.toUpperCase())}
              </div>
            </div>
            {/* Image Index */}
            <div className="px-2 fs-6 text-body-secondary">
              {`Index: ${index + 1}`}
            </div>
            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                imageInfo.message !== "" ? "" : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {imageInfo.message}
            </div>
          </div>

          {/* Right side views spinner, download and delete buttons */}
          <div
            className="position-absolute justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            {/* Download button */}
            <div
              className={`my-auto me-2 ms-1 ${
                imageInfo.state === AppState.PROCESSED ? "" : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-success"
                onClick={async (e) => {
                  //stop propagating
                  e.stopPropagation();
                  //check
                  if (imageInfo.cropped_blob !== null) {
                    //blob
                    const blob = imageInfo.cropped_blob;
                    //save
                    await saveFile(
                      blob,
                      `${imageInfo.name}.${getExtensionFromMimeType(blob.type)}`,
                    );
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-download"
                  viewBox="0 0 16 16"
                >
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                </svg>
              </button>
            </div>
            {/* Show spinner while processing */}
            {/* Spinner */}
            <div
              className={`spinner-border my-auto me-2 ms-sm-3 ms-2 ${
                imageInfo.state === AppState.PROCESSING ? "" : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Delete Button */}
            {/* Show delete button after loaded */}
            <div
              className={`my-auto me-2 ms-1 ${
                imageInfo.state === AppState.LOADED ||
                imageInfo.state === AppState.NONE
                  ? ""
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={(e) => {
                  //stop propagating
                  e.stopPropagation();
                  //remove file from selectedfiles list
                  setSelectedFiles(selectedFiles.filter((a) => a !== item));
                  //remove thumbnails
                  setImageInfo({});
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    //show hide loading view
    <div className="position-relative">
      {/* Popup crop rect select */}
      {showSelectRectPopup.showing ? (
        <CropRectSelectPopup
          pageImage={showSelectRectPopup.image}
          pageDimension={showSelectRectPopup.imageDimension}
          outputSettings={{ outputSettings, setOutputSettings }}
          onClose={(cropPerctRect) => {
            //hide popup
            setShowSelectRectPopup({ ...showSelectRectPopup, showing: false });
          }}
        />
      ) : (
        <></>
      )}

      {/* show image preview */}
      {/* page main content */}
      {showImagePreview.preview ? (
        <ImageViewerView
          title={
            showImagePreview.file === null ? "" : showImagePreview.file.name
          }
          onClose={() => {
            //set preview
            setShowImagePreview({
              ...showImagePreview,
              preview: false,
              file: null,
            });
          }}
          file={showImagePreview.file}
        ></ImageViewerView>
      ) : (
        <div>
          {/* Top bar */}
          <div className="bg-light border-bottom my-auto sticky-top">
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={resetScreen}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  fill="#000000"
                  className="bi bi-arrow-clockwise"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </button>
              {/* Title */}
              <label className="fs-3 ms-2 py-2 text-secondary fs-4">
                {props.title ?? "Crop Images"}
              </label>
            </div>
          </div>

          {/*Container left list & right controls */}
          <div
            className="d-flex"
            style={{
              height: "calc(100vh - 52px)",
              maxHeight: "calc(100vh - 52px)",
            }}
          >
            {/* Left List */}
            <div
              className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
              style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
            >
              {renderFilesListView()}
            </div>

            {/* Right controls */}
            <div
              className="ms-sm-5 ms-1  border-start position-relative"
              style={{
                marginBottom: "100px", //add space to bottom for button, else overlap
                width: "25%",
                maxWidth: "25%",
                overflowY: "auto",
                minWidth: "200px",
              }}
            >
              {/* Right half */}
              <div className="ms-4 me-4 mt-5 mb-2">
                {/* Crop rect */}
                <div className="d-flex border-bottom pb-1">
                  <label
                    htmlFor="croprect"
                    className="form-label fs-4 text-dark"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Crop rect position & dimension"
                  >
                    Crop Rectangle:
                  </label>
                </div>

                {/* Crop rect x */}
                <div className="mt-3 d-flex">
                  {/* label */}
                  <label className="my-auto">X position (px):</label>
                  {/* Input */}
                  <input
                    type="number"
                    className="form-control ms-2"
                    id="x_pos"
                    value={Math.floor(
                      (outputSettings.cropX *
                        showSelectRectPopup.imageDimension[0]) /
                        100,
                    )}
                    onChange={(e) => {
                      //set
                      setOutputSettings({
                        ...outputSettings,
                        cropX: Math.max(
                          0,
                          Math.min(
                            100,
                            (e.target.value /
                              showSelectRectPopup.imageDimension[0]) *
                              100,
                          ),
                        ),
                      });
                    }}
                    placeholder="origin X"
                    style={{ width: "80px" }}
                  />
                </div>
                {/* Crop rect y */}
                <div className="mt-1 d-flex">
                  {/* label */}
                  <label className="my-auto">Y position (px): </label>
                  {/* Input */}
                  <input
                    type="number"
                    className="form-control ms-2"
                    id="y_pos"
                    value={Math.floor(
                      (outputSettings.cropY *
                        showSelectRectPopup.imageDimension[1]) /
                        100,
                    )}
                    onChange={(e) => {
                      //set
                      setOutputSettings({
                        ...outputSettings,
                        cropY: Math.max(
                          0,
                          Math.min(
                            100,
                            (e.target.value /
                              showSelectRectPopup.imageDimension[1]) *
                              100,
                          ),
                        ),
                      });
                    }}
                    placeholder="origin Y"
                    style={{ width: "80px" }}
                  />
                </div>
                {/* Crop rect width */}
                <div className="mt-1 d-flex">
                  {/* label */}
                  <label className="my-auto">Width (px):</label>
                  {/* Input */}
                  <input
                    type="number"
                    className="form-control ms-2"
                    id="Width"
                    value={Math.floor(
                      (outputSettings.cropWidth *
                        showSelectRectPopup.imageDimension[0]) /
                        100,
                    )}
                    onChange={(e) => {
                      //set
                      setOutputSettings({
                        ...outputSettings,
                        cropWidth: Math.max(
                          0,
                          Math.min(
                            100,
                            (e.target.value /
                              showSelectRectPopup.imageDimension[0]) *
                              100,
                          ),
                        ),
                      });
                    }}
                    placeholder="Width"
                    style={{ width: "80px" }}
                  />
                </div>
                {/* Crop rect height */}
                <div className="mt-1 d-flex">
                  {/* label */}
                  <label className="my-auto">Height (px):</label>
                  {/* Input */}
                  <input
                    type="number"
                    className="form-control ms-2"
                    id="height"
                    value={Math.floor(
                      (outputSettings.cropHeight *
                        showSelectRectPopup.imageDimension[1]) /
                        100,
                    )}
                    onChange={(e) => {
                      //set
                      setOutputSettings({
                        ...outputSettings,
                        cropHeight: Math.max(
                          0,
                          Math.min(
                            100,
                            (e.target.value /
                              showSelectRectPopup.imageDimension[1]) *
                              100,
                          ),
                        ),
                      });
                    }}
                    placeholder="Height"
                    style={{ width: "80px" }}
                  />
                </div>

                {/* Select crop rect from page number */}
                <div className="mt-3 me-4">
                  <button
                    className="btn btn-outline-success"
                    onClick={async (e) => {
                      //set image
                      setShowSelectRectPopup({
                        ...showSelectRectPopup,
                        showing: true,
                      });
                    }}
                  >
                    Select Crop Rectangle
                  </button>
                </div>

                {/* Output settingd */}
                <div className="d-flex border-bottom pb-1 mt-5">
                  <label
                    className="form-label fs-4 text-dark"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Output Settings"
                  >
                    Output Settings:
                  </label>
                </div>

                {/* Output image file type */}
                <div className="d-flex mt-4 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Export as:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenuImageType"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //toggle
                        setOutputSettings({
                          ...outputSettings,
                          type: {
                            ...outputSettings.type,
                            popupShowing:
                              outputSettings.type.popupShowing === true
                                ? false
                                : true,
                          },
                        });
                      }}
                    >
                      {outputSettings.type.export_as}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        outputSettings.type.popupShowing === true ? "show" : ""
                      }`}
                      aria-labelledby="dropdownMenuImageType"
                    >
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".jpg",
                              mimetype: "image/jpg",
                            },
                          });
                        }}
                      >
                        .jpg
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".jpeg",
                              mimetype: "image/jpeg",
                            },
                          });
                        }}
                      >
                        .jpeg
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".png",
                              mimetype: "image/png",
                            },
                          });
                        }}
                      >
                        .png
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".bmp",
                              mimetype: "image/bmp",
                            },
                          });
                        }}
                      >
                        .bmp
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".webp",
                              mimetype: "image/webp",
                            },
                          });
                        }}
                      >
                        .webp
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".svg",
                              mimetype: "image/svg+xml",
                            },
                          });
                        }}
                      >
                        .svg
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Convert Button */}
              <button
                className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                  isCropping ? "disabled" : ""
                }`}
                style={{
                  marginLeft: "10px",
                  width:
                    window !== undefined
                      ? window.innerWidth * 0.25 < 200
                        ? "180px"
                        : window.innerWidth * 0.25 - 40
                      : "180px",
                  bottom: "10px",
                  lineHeight: "1.1",
                }}
                type="button"
                onClick={async (e) => {
                  //set
                  setIsCropping(true);
                  //set status
                  setImageInfo({
                    ...imageInfo,
                    state: AppState.PROCESSING,
                    message: "Processing image...",
                  });

                  //crop
                  if (selectedFiles.length > 0) {
                    //crop
                    const croppedImageBlob = await cropImage(
                      selectedFiles[0],
                      Math.floor(
                        (outputSettings.cropX *
                          showSelectRectPopup.imageDimension[0]) /
                          100,
                      ),
                      Math.floor(
                        (outputSettings.cropY *
                          showSelectRectPopup.imageDimension[1]) /
                          100,
                      ),
                      Math.floor(
                        (outputSettings.cropWidth *
                          showSelectRectPopup.imageDimension[0]) /
                          100,
                      ),
                      Math.floor(
                        (outputSettings.cropHeight *
                          showSelectRectPopup.imageDimension[1]) /
                          100,
                      ),
                      outputSettings.type.mimetype,
                    );

                    //set blob
                    //set status
                    setImageInfo({
                      ...imageInfo,
                      state: AppState.PROCESSED,
                      message:
                        "Successfully cropped image. Click on download button to save.",
                      cropped_blob:
                        croppedImageBlob === null
                          ? selectedFiles[0]
                          : croppedImageBlob,
                      cropped_size:
                        croppedImageBlob === null ? 0 : croppedImageBlob.size,
                    });
                  }
                  //reset
                  setIsCropping(false);
                }}
              >
                CROP IMAGE
                <br />
                <span className="fs-6">With selected rectangle</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CropImageListImagesScreen;
